<template>
    <div class="scope-menu-tabs">
        <div
            :class="['scope-menu-tab', { '-active': currentTab == tab.id }]"
            v-for="(tab, index) in tabs"
            @click="goToSection(tab.id)"
            :key="index"
        >
            {{ tab.name }}
        </div>
    </div>
</template>
<script setup>
defineProps({
    tabs: Array
});
const currentTab = defineModel();
const goToSection = (tabId) => {
    currentTab.value = tabId;
};
</script>
<style lang="scss" scoped>
@import '../assets/styles/_main.scss';

.scope-menu-tabs {
    height: 40px;
    display: flex;
    gap: 24px;
    padding: 0 24px;
    border-bottom: 1px solid $border;
    background: transparent;

    .scope-menu-tab {
        color: $text-mid-emphasis;

        @include fz-14;
        font-weight: 500;
        text-wrap: nowrap;
        padding: 8px 0;
        cursor: pointer;

        &.-active {
            color: $text-high-emphasis;
            border-bottom: 2px solid $primary-accent;
            transition-duration: 200ms;
            transition-property: transform, border-bottom;
        }
    }
}

body[theme='dark'] .scope-menu-tabs {
    border-bottom: 1px solid $border;
    background: transparent;

    .scope-menu-tab {
        color: $text-mid-emphasis;

        &.-active {
            color: $text-high-emphasis;
            border-bottom: 2px solid $primary-accent;
        }
    }
}
</style>
